<script setup lang="ts">
    import { ILibraryDashboard } from '@/js/services/api/library/types';
    import EchoButton from '../EchoButton.vue';
    import { __ } from '@/js/stores/expressions';

    interface Props {
        dashboard: ILibraryDashboard;
    }

    defineProps<Props>();
</script>

<template>
    <div
        class="h-full w-full rounded-lg border-1 border-gray-light p-6 grid grid-cols-1 md:grid-cols-2 gap-1"
    >
        <img
            :alt="dashboard.title + '-preview'"
            class="rounded-lg border-1 border-gray-light h-50 w-full"
        />
        <div class="flex flex-col justify-center md:pl-8">
            <h2 class="text-xl">
                {{ dashboard.title }}
            </h2>
            <p class="text-md font-normal">
                {{ dashboard.description }}
            </p>
            <div class="inline-block">
                <EchoButton :route="{ path: 'preview-dashboard', query: { id: dashboard.id } }">
                    {{ __('library-preview') }}
                </EchoButton>
            </div>
        </div>
    </div>
</template>
